import { useEffect, useState } from 'react';

export function useDocumentIsHidden() {
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    const abortController = new AbortController();
    const { signal } = abortController;
    addEventListener(
      'visibilitychange',
      () => {
        setIsHidden(document.hidden);
      },
      { signal }
    );
    return () => {
      abortController.abort();
    };
  }, []);

  return isHidden;
}
